import React, { useContext, useState, useEffect, useRef } from "react";
import Space from "antd/es/space";
import Input from "antd/es/input";
import Alert from "antd/es/alert";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { GlobalStoreContext } from "@/context";
import { getAdmin } from "@/server/adminManager";
import "./index.less";

export default function Login() {
  const { isLogin, setIsLogin } = useContext(GlobalStoreContext);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("用户名或密码错误");
  const account = useRef("");
  const password = useRef("");
  const navigate = useNavigate();

  const toMain = () => {
    navigate("/main");
  };

  const login = () => {
    const acc = account.current;
    const pas = password.current;
    if (acc !== "" && pas !== "") {
      // 登录

      // 成功之后
      getAdmin({
        account: acc,
        password: pas,
      }).then((res) => {
        if (res) {
          localStorage.setItem("tgb_admin_account", account.current);
          localStorage.setItem("tgb_admin_password", password.current);
          localStorage.setItem("tgb_admin_id", res.admin_id);
          setIsLogin(true);
          setShowError(false);
          toMain();
        } else {
          setShowError(true);
        }
      });
    } else {
      setShowError(true);
    }
  };

  useEffect(() => {
    console.log(isLogin, "islogi logalkskdlkajd");
    if (isLogin) {
      toMain();
    } else {
      const acc = localStorage.getItem("tgb_admin_account");
      const pas = localStorage.getItem("tgb_admin_password");
      if (acc && pas) {
        account.current = acc;
        password.current = pas;
        login();
      }
    }
  }, []);

  return (
    <div className="login-wrap flex-col justify-center">
      <div className="input-area">
        <div className="title flex-row items-center justify-center">
          <img src={require("@/assets/imgs/logo-colorful.png")} alt="" />
          <span>TGB科技管理端</span>
        </div>
        <Space direction="vertical" size={28}>
          <div className="tab items-start flex-col">
            登录
            <div className="line" />
          </div>
          <Input
            style={{ borderRadius: 2 }}
            placeholder="请输入账号"
            prefix={<UserOutlined style={{ color: "#1890FF" }} />}
            onChange={(e) => {
              account.current = e.target.value;
            }}
          />
          <Input.Password
            style={{ borderRadius: 2 }}
            placeholder="请输入密码"
            prefix={<LockOutlined style={{ color: "#1890FF" }} />}
            onChange={(e) => {
              password.current = e.target.value;
            }}
          />
          <Space direction="vertical" size={22}>
            {showError && (
              <Alert
                message={errorMsg}
                type="error"
                showIcon={true}
                style={{
                  color: "#ff2e2e",
                }}
              />
            )}
            <div
              className="submit"
              onClick={() => {
                login();
              }}
            >
              登录
            </div>
          </Space>
        </Space>
      </div>
      <img
        className="big-logo"
        src={require("@/assets/imgs/logo-colorful.png")}
        alt=""
      />
    </div>
  );
}
